import { message } from 'antd'
import { invoiceRetentionPayment } from '../../../HttpRequests/retentionPayments'
import fetch from './fetch'
import handleException from '../../../Core/Helpers/handleException'

export default (id) => async (dispatch) => {

  try {

    await invoiceRetentionPayment({ id })

    await dispatch(fetch())

    message.success('Invoiced')
    
  } catch (error) {

    handleException(error)

  }
  
}